import { Injectable } from '@angular/core';
import { AdalService } from 'adal-angular4';
import { OAuthService } from 'angular-oauth2-oidc';
import { Routes, RouterModule, Router } from '@angular/router';
@Injectable({ providedIn: 'root'})
export class LoginService {

  constructor(private adalService: AdalService, private oauthService: OAuthService,private router: Router,) { }

  login() {    
    this.adalService.login();
  }

  logout() {
    localStorage.setItem('Logout', "true");
    this.oauthService.logOut(); // Pass true to clear the sessionStorage
    
    this.router.navigate(['login']);
   
  }
}
